import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { FC } from 'react';
import { MdClose, MdUpload } from 'react-icons/md';

import { DialogTitle } from '../dialogs/dialog-title';
import { FileNameField } from './file-name-field';

export type TRenameFileDialogProps = {
  open: boolean;
  fileName: string;
  onFileNameChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
};

/** Name-only step shown before a non-image file (PDF) uploads. */
export const RenameFileDialog: FC<TRenameFileDialogProps> = ({
  open,
  fileName,
  onFileNameChange,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle onClose={onCancel}>Name your file</DialogTitle>
    <DialogContent sx={{ pt: 1 }}>
      <FileNameField value={fileName} onChange={onFileNameChange} onEnter={onConfirm} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} variant="soft" startIcon={<MdClose />}>
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" startIcon={<MdUpload />}>
        Upload
      </Button>
    </DialogActions>
  </Dialog>
);
